// Import model
import { PickListItemCondition } from '../models/PickListItemCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { PickListItemIndexedFields } from '../models/PickListItemIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { PickListItemIndexedFieldsSerializer } from './PickListItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for PickListItemCondition - handles JSON serialization and deserialization with type validation
 */
export class PickListItemConditionSerializer {
  /**
   * Deserializes a JSON string into a PickListItemCondition instance
   */
  static deserialize(json: string): PickListItemCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a PickListItemCondition instance
   */
  static fromObject(obj: any): PickListItemCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to PickListItemCondition');
    }


    const instance: PickListItemCondition = {
      fieldName: obj['fieldName'] as PickListItemIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of PickListItemCondition instances
   */
  static deserializeArray(json: string): PickListItemCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a PickListItemCondition instance to a JSON string
   */
  static serialize(instance: PickListItemCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a PickListItemCondition instance to a plain object
   */
  static toObject(instance: PickListItemCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of PickListItemCondition instances to a JSON string
   */
  static serializeArray(instances: PickListItemCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
